export default "__VITE_ASSET__ByhgqYW2__"